import { format } from "date-fns";
import { BankTransactionDto } from "../../../dtos/transactions/BankTransactionDto";
import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import React from "react";

interface IProps {
    items: BankTransactionDto[];
}

export const BankTransactionTable = ({ items }: IProps) => {
    const pageSizes = [10, 25, 50, 100];

    return (
        <>
            <div className={"overflow-auto"}>
                <DataGrid
                    dataSource={items}
                    sorting={{ mode: "multiple" }}
                    allowColumnReordering={true}
                    rowAlternationEnabled={false}
                    showBorders={false}
                    showRowLines={true}
                    allowColumnResizing={true}
                    selection={{ mode: "single" }}
                    loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
                >
                    <ColumnChooser enabled={true} />
                    <GroupPanel visible={true} />
                    <SearchPanel visible={true} highlightCaseSensitive={true} />
                    <Grouping autoExpandAll={false} />

                    <Column dataField="tableMovementType"
                            dataType="string"
                            caption={"Movement Type"}
                            width={100}
                            cellRender={(column: any) => {
                                return <MovementTypeColumn column={column} />
                            }} />
                    
                    <Column width={150} dataField={"period"} dataType={"datetime"} caption={"Period"}
                        sortOrder={"asc"}
                        sortIndex={1} />

                    <Column width={100} dataField={"companyId"} dataType="string" />
                    <Column width={100} dataField={"companyName"} dataType="string" />
                    <Column width={100} dataField={"currencyName"} dataType="string" />
                    <Column width={100} dataField={"cashFlowItemId"} dataType="string" />
                    <Column width={100} dataField={"cashFlowItemName"} dataType="string" />
                    <Column width={100} dataField={"amount"} dataType="number" />
                    <Column width={100} dataField={"currencyAmount"} dataType="number" />
                    <Column width={100} dataField={"bankAccountId"} dataType="string" />
                    <Column width={100} dataField={"bankAccountName"} dataType="string" />

                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                    <Paging defaultPageSize={10} />
                </DataGrid>
            </div>
        </>
    )
}
